@if (showSkeleton()) {
  <app-form-skeleton/>
} @else {
  <div class="modal-content">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        @if (RoleService.currentRole === Roles.ADMIN || RoleService.currentRole === Roles.COMPANY_GROUP_MANAGER) {
          <div class="col-12">
            <autocomplete
              [clearable]="false"
              [url]="getCompanies.bind(this)"
              formControlName="companyId"
              bindLabel="companyName"
              searchKey="search"
              inputValidator
              label="RESIDENTS.COMPANY_NAME"
            />
          </div>
        }
        <kep-file-input
          [limit]="10"
          label="{{ 'DOCUMENT.FILE' | translate }}"
          formControlName="csv_file"
          acceptType=".csv"
        />
        <div class="text-end mt-3">
          <p-button
            type="submit"
            styleClass="btn btn-primary"
            [disabled]="isPending()"
            [loading]="isPending()"
            [label]="'SAVE' | translate"
          />
          <button
            type="button"
            class="btn btn-soft-primary ms-2"
            (click)="cancel()"
          >
            {{ 'CANCEL'|translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
}
